<template lang="html">
	<vddl-draggable class="panel__body--item column"
					:draggable="item"
					:index="index"
					:wrapper="list"
					:type="type"
					:moved="handleMovedList"
					v-bind:class="{'search-highlight': isHighlighted}">
		<div class="column-content" v-if="item">
			<div class="column-drag">
				<span class="fa fa-ellipsis-v drag"></span>
			</div>
			<div class="column-fields">
				<!-- Attribute field (read-only, auto-filled) -->
				<div class="column-field">
					<label class="field-label">Attribute:</label>
					<span class="field-value readonly">{{ item.attribute }}</span>
				</div>

				<!-- Title field (editable) -->
				<div class="column-field editable-field">
					<label class="field-label">Title:</label>
					<span class="field-value" v-if="!editingFields.title">
						{{ item.title || item.attribute }}
					</span>
					<input type="text"
						   v-if="editingFields.title"
						   v-model="item.title"
						   class="field-input"
						   @blur="stopEditing('title')"
						   @keyup.enter="stopEditing('title')">
					<span class="fa fa-pencil edit-icon"
						  v-if="!editingFields.title"
						  @click="startEditing('title')"></span>
				</div>

				<!-- Language field (editable with select, only for SL attributes) -->
				<div class="column-field editable-field" v-if="isSLAttribute">
					<label class="field-label">Language:</label>
					<span class="field-value" v-if="!editingFields.language">
						{{ item.language || '-' }}
					</span>
					<select v-if="editingFields.language"
							v-model="item.language"
							class="field-select"
							@blur="handleLanguageBlur"
							@change="handleLanguageBlur">
						<option :value="undefined">-</option>
						<option v-for="(lang, key) in languages" :key="key" :value="key">
							{{ key }}
						</option>
					</select>
					<span class="fa fa-pencil edit-icon"
						  v-if="!editingFields.language"
						  @click="startEditing('language')"></span>
				</div>

				<!-- Align field (editable with select) -->
				<div class="column-field editable-field">
					<label class="field-label">Align:</label>
					<span class="field-value" v-if="!editingFields.align">
						{{ item.align || '-' }}
					</span>
					<select v-if="editingFields.align"
							v-model="item.align"
							class="field-select"
							@blur="handleAlignBlur"
							@change="handleAlignBlur">
						<option :value="null">-</option>
						<option value="left">left</option>
						<option value="right">right</option>
						<option value="center">center</option>
						<option value="justify">justify</option>
						<option value="inherit">inherit</option>
					</select>
					<span class="fa fa-pencil edit-icon"
						  v-if="!editingFields.align"
						  @click="startEditing('align')"></span>
				</div>

				<!-- Width field (editable) -->
				<div class="column-field editable-field">
					<label class="field-label">Width:</label>
					<span class="field-value" v-if="!editingFields.width">
						{{ item.width || '-' }}
					</span>
					<input type="number"
						   v-if="editingFields.width"
						   v-model.number="item.width"
						   class="field-input"
						   min="1"
						   placeholder="px"
						   @blur="handleWidthBlur"
						   @keyup.enter="handleWidthBlur">
					<span class="fa fa-pencil edit-icon"
						  v-if="!editingFields.width"
						  @click="startEditing('width')"></span>
				</div>

				<!-- Index field (editable, only for multiple attributes) -->
				<div class="column-field editable-field" v-if="isMultipleAttribute">
					<label class="field-label">Index:</label>
					<span class="field-value" v-if="!editingFields.index">
						{{ item.index !== undefined ? item.index : '-' }}
					</span>
					<input type="number"
						   v-if="editingFields.index"
						   v-model.number="item.index"
						   class="field-input"
						   min="0"
						   placeholder="0, 1, 2..."
						   @blur="handleIndexBlur"
						   @keyup.enter="handleIndexBlur">
					<span class="fa fa-pencil edit-icon"
						  v-if="!editingFields.index"
						  @click="startEditing('index')"></span>
				</div>
			</div>
			<div class="column-actions">
				<span class="fa fa-trash delete-icon" title="Delete" @click="deleteElement(item)"></span>
			</div>
		</div>
	</vddl-draggable>
</template>

<script>
export default {
	name: 'list-column',
	data () {
		return {
			type: 'list',
			editingFields: {
				title: false,
				language: false,
				align: false,
				width: false,
				index: false
			}
		}
	},
	props: [
		'item',
		'list',
		'index',
		'localization',
		'itemStructure',
		'toggleInputEdit',
		'onDelete',
		'searchText',
		'languages'
	],
	computed: {
		isHighlighted() {
			if (!this.searchText || this.searchText === '') return false
			const searchLower = this.searchText.toLowerCase()
			const attribute = this.item.attribute ? this.item.attribute.toLowerCase() : ''
			const title = this.item.title ? this.item.title.toLowerCase() : ''
			const localization = this.itemStructure[this.item.attribute] ?
				(this.$t(this.itemStructure[this.item.attribute].title) || this.itemStructure[this.item.attribute].title || '').toLowerCase() : ''
			return attribute.indexOf(searchLower) !== -1 || title.indexOf(searchLower) !== -1 || localization.indexOf(searchLower) !== -1
		},
		isMultipleAttribute() {
			// Check if attribute exists in itemStructure and has multiple: true
			if (!this.item.attribute || !this.itemStructure || !this.itemStructure[this.item.attribute]) {
				return false
			}
			return this.itemStructure[this.item.attribute].multiple === true
		},
		isSLAttribute() {
			// Check if attribute exists in itemStructure and has type: 'SL'
			if (!this.item.attribute || !this.itemStructure || !this.itemStructure[this.item.attribute]) {
				return false
			}
			return this.itemStructure[this.item.attribute].type === 'SL'
		}
	},
	methods: {
		handleMovedList (item) {

		},
		startEditing(field) {
			this.editingFields[field] = true
			this.$nextTick(() => {
				const input = this.$el.querySelector('.field-input, .field-select')
				if (input) input.focus()
			})
		},
		stopEditing(field) {
			this.editingFields[field] = false
		},
		handleLanguageBlur() {
			// Clean up empty language value
			if (this.item.language === '' || this.item.language === null || this.item.language === undefined) {
				this.$delete(this.item, 'language')
			}
			this.stopEditing('language')
		},
		handleAlignBlur() {
			// Clean up empty align value
			if (this.item.align === '' || this.item.align === null || this.item.align === undefined) {
				this.$delete(this.item, 'align')
			}
			this.stopEditing('align')
		},
		handleWidthBlur() {
			// Clean up invalid or empty width value
			if (!this.item.width || this.item.width <= 0) {
				this.$delete(this.item, 'width')
			}
			this.stopEditing('width')
		},
		handleIndexBlur() {
			// Clean up invalid index value
			if (this.item.index === null || this.item.index === '' || this.item.index < 0) {
				this.$delete(this.item, 'index')
			}
			this.stopEditing('index')
		},
		deleteElement (item) {
			if (this.onDelete) {
				this.onDelete(item)
			}
		}
	},
	created () {

	}
}
</script>

<style lang="scss" scoped>
.column-content {
	display: flex;
	align-items: flex-start;
	width: 100%;
	position: relative;
}

.column-drag {
	flex-shrink: 0;
	padding-right: 10px;
}

.column-fields {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.column-field {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;

	&.editable-field {
		position: relative;
	}
}

.field-label {
	font-weight: 600;
	color: #666;
	min-width: 80px;
	margin: 0;
}

.field-value {
	color: #333;

	&.readonly {
		color: #999;
		font-style: italic;
	}
}

.field-input, .field-select {
	flex: 1;
	padding: 4px 8px;
	border: 1px solid #ddd;
	border-radius: 3px;
	font-size: 14px;

	&:focus {
		outline: none;
		border-color: #0090d0;
	}
}

.field-select {
	cursor: pointer;
	background-color: #fff;
}

.edit-icon {
	color: #6888a8;
	cursor: pointer;
	padding: 4px;
	border-radius: 3px;
	transition: all 0.2s;
	opacity: 0;

	&:hover {
		background-color: #f0f0f0;
	}
}

.editable-field:hover .edit-icon {
	opacity: 1;
}

.column-actions {
	position: absolute;
	right: 10px;
	top: 10px;
	display: flex;
	gap: 5px;
}

.delete-icon {
	color: #ff00008a;
	cursor: pointer;
	padding: 5px;
	border-radius: 50%;
	background-color: #f5f5f5;
	opacity: 0;
	transition: all 0.2s;

	&:hover {
		background-color: #ffe0e0;
		color: #ff0000;
	}
}

.column:hover .delete-icon {
	opacity: 1;
}

.search-highlight {
	background-color: #fff3cd !important;
	border-left: 3px solid #ffc107;
}

.drag {
	color: #c1c1c1;
}
</style>
